export default __webpack_public_path__ + "static/media/CNo.33-5.88afe8cf.jpg";